// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared styling for the Nakit Akış / Sözleşme-Fatura / İnşaat-Enerji modules */

.nf-module {
  padding: 16px;
}

.nf-module .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 8px 8px 0 0;
}

/* Tables: clearer headers, zebra rows, rounded container, tighter cells */
.nf-module .ant-table-wrapper {
  border: 1px solid #eef0f2;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.nf-module .ant-table-thead > tr > th {
  background: #f4f6f8 !important;
  font-weight: 600;
  color: #1f2d3d !important;
  border-bottom: 1px solid #e6e9ec !important;
  white-space: nowrap;
  /* Kompakt: global sızan 16px !important padding'i ez */
  padding: 6px 10px !important;
}

.nf-module .ant-table-tbody > tr:nth-child(even) > td {
  background: #fafbfc;
}

.nf-module .ant-table-tbody > tr:hover > td {
  background: #eef6ff !important;
}

.nf-module .ant-table-tbody > tr > td {
  padding: 3px 10px !important;
  font-size: 13px;
}

/* Kompakt filtre/araç çubuğu ve modal formları */
.nf-module .ant-table-cell { line-height: 1.4; }
.nf-module .ant-pagination { margin: 8px 0 !important; }
.nf-module .ant-form-item { margin-bottom: 12px; }

/* Numeric / amount cells stay on one line */
.nf-module .ant-table-cell span.nf-amount {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

/* Filter toolbars */
.nf-module .ant-space-item {
  margin-bottom: 4px;
}

.nf-module .ant-card {
  border-radius: 10px;
}

/* ---- Dark theme ---- */
body.dark-theme .nf-module .ant-table-wrapper {
  border-color: #303030;
  box-shadow: none;
}
body.dark-theme .nf-module .ant-table-thead > tr > th {
  background: #1f1f1f;
  color: var(--color-text, #e6e6e6);
  border-bottom: 1px solid #303030;
}
body.dark-theme .nf-module .ant-table-tbody > tr:nth-child(even) > td {
  background: rgba(255, 255, 255, 0.02);
}
body.dark-theme .nf-module .ant-table-tbody > tr:hover > td {
  background: rgba(24, 144, 255, 0.16) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ortak/nfmodules.css"],"names":[],"mappings":"AAAA,gFAAgF;;AAEhF;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,0EAA0E;AAC1E;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,2CAA2C;EAC3C,mBAAmB;EACnB,uDAAuD;EACvD,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,iDAAiD;AACjD,6BAA6B,gBAAgB,EAAE;AAC/C,6BAA6B,wBAAwB,EAAE;AACvD,4BAA4B,mBAAmB,EAAE;;AAEjD,4CAA4C;AAC5C;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,gCAAgC;AAClC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,+CAA+C;AACjD","sourcesContent":["/* Shared styling for the Nakit Akış / Sözleşme-Fatura / İnşaat-Enerji modules */\n\n.nf-module {\n  padding: 16px;\n}\n\n.nf-module .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {\n  border-radius: 8px 8px 0 0;\n}\n\n/* Tables: clearer headers, zebra rows, rounded container, tighter cells */\n.nf-module .ant-table-wrapper {\n  border: 1px solid #eef0f2;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.nf-module .ant-table-thead > tr > th {\n  background: #f4f6f8 !important;\n  font-weight: 600;\n  color: #1f2d3d !important;\n  border-bottom: 1px solid #e6e9ec !important;\n  white-space: nowrap;\n  /* Kompakt: global sızan 16px !important padding'i ez */\n  padding: 6px 10px !important;\n}\n\n.nf-module .ant-table-tbody > tr:nth-child(even) > td {\n  background: #fafbfc;\n}\n\n.nf-module .ant-table-tbody > tr:hover > td {\n  background: #eef6ff !important;\n}\n\n.nf-module .ant-table-tbody > tr > td {\n  padding: 3px 10px !important;\n  font-size: 13px;\n}\n\n/* Kompakt filtre/araç çubuğu ve modal formları */\n.nf-module .ant-table-cell { line-height: 1.4; }\n.nf-module .ant-pagination { margin: 8px 0 !important; }\n.nf-module .ant-form-item { margin-bottom: 12px; }\n\n/* Numeric / amount cells stay on one line */\n.nf-module .ant-table-cell span.nf-amount {\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Filter toolbars */\n.nf-module .ant-space-item {\n  margin-bottom: 4px;\n}\n\n.nf-module .ant-card {\n  border-radius: 10px;\n}\n\n/* ---- Dark theme ---- */\nbody.dark-theme .nf-module .ant-table-wrapper {\n  border-color: #303030;\n  box-shadow: none;\n}\nbody.dark-theme .nf-module .ant-table-thead > tr > th {\n  background: #1f1f1f;\n  color: var(--color-text, #e6e6e6);\n  border-bottom: 1px solid #303030;\n}\nbody.dark-theme .nf-module .ant-table-tbody > tr:nth-child(even) > td {\n  background: rgba(255, 255, 255, 0.02);\n}\nbody.dark-theme .nf-module .ant-table-tbody > tr:hover > td {\n  background: rgba(24, 144, 255, 0.16) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
